import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class PersonneMoraleExtendedList extends ShadowDOMElement {
	static className = "PersonneMoraleExtendedList";
	
	static properties = {
		sigle: { type: Boolean, attribute: "sigle", reflect: true },
		representative: { type: Boolean, attribute: "representative", reflect: true },
		greffe : {
			type: Boolean, attribute: "greffe", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
	};

	constructor() {
		super();
		this.managers = [];
		this.sigle = false;
		this.representative = false;
		this.greffe = false;
	}

	firstUpdated() {
		super.firstUpdated();
		this.addManager();
	}

	addManager() {
		const managerContainer = document.createElement("personne-morale-extended");
		managerContainer.setAttribute("sigle", this.sigle);
		managerContainer.setAttribute("representative", this.representative);
		managerContainer.setAttribute("greffe", this.greffe);

		if (this.managers.length > 0) {
			const deleteButtonWrapper = this.createDeleteButton(managerContainer);
			this.appendChild (deleteButtonWrapper);
		}

		this.managers.push(managerContainer);
		this.appendChild (managerContainer);
	}

	removeManager(managerContainer, deleteButtonWrapper) {
		this.managers = this.managers.filter((manager) => manager !== managerContainer);
		this.removeChild(managerContainer);
		if (deleteButtonWrapper)
			this.removeChild(deleteButtonWrapper);
	}

	createDeleteButton(managerContainer) {
		const deleteButtonWrapper = document.createElement("row-wrapper");
		const deleteButton = document.createElement("button-field");

		deleteButton.onClickHandler = () => {
			this.removeManager(managerContainer, deleteButtonWrapper);
		};

		deleteButton.innerHTML = `<i class="fa fa-minus"></i><span>&nbsp;Supprimer</span>`;
		deleteButtonWrapper.appendChild(deleteButton);

		return deleteButtonWrapper;
	}

	render() {
		return html`
		<slot></slot>
		<row-wrapper data-add-button="true">
			<button-field .onClickHandler="${this.addManager.bind(this)}">
				<i class="fa fa-plus"></i><span>&nbsp;Ajouter une personne morale</span>
			</button-field>
		</row-wrapper>
	    `;
	}
	
	isTransient (){
		return false;
	}

	getValues (){
		return {
			"count" : this.managers.length || 1,
			... super.getValues ()
		}
	}

	setValues (values){
		while (this.managers.length < values.count)
	        this.addManager ();
		super.setValues (values);
	}
}

customElements.define("personne-morale-extended-list", PersonneMoraleExtendedList);
